export default __webpack_public_path__ + "content/6eb6951713594b4bf2bbd5c6b3e93034.ttf";